import { render, staticRenderFns } from "./IconEditUser.vue?vue&type=template&id=a6926058"
import script from "./IconEditUser.vue?vue&type=script&lang=js"
export * from "./IconEditUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports